import React from "react";

import { parseISO, format } from "date-fns";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DOCUMENT_TYPE_LABELS = {
  CPF: "CPF",
  CNPJ: "CNPJ",
  PLATE: "Placa",
  PHONE: "Telefone"
};

export function BlackList({
  blackListData,
  handleOpenAttachment,
  handleActivateDocument,
  handleDeleteDocument,
  isOperating
}) {
  const formatDocument = (type, value) => {
    if (!value) return "";

    const onlyDigits = value.replace(/\D/g, "");

    if (type === "CPF") {
      if (onlyDigits.length !== 11) return value;
      return onlyDigits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    if (type === "CNPJ") {
      if (onlyDigits.length !== 14) return value;
      return onlyDigits.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }

    if (type === "PLATE") {
      return value.toUpperCase();
    }

    if (type === "PHONE") {
      if (onlyDigits.length === 11) {
        return onlyDigits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
      }
      if (onlyDigits.length === 10) {
        return onlyDigits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
      }
      return value;
    }
    return value;
  };
  return (
    <>
      <div className="row mb-10">
        <div className="col-xl-12">
          <div
            style={{
              backgroundColor: "#fff",
              border: "1px solid #eaeaea",
              borderRadius: "5px",
              padding: "20px"
            }}
          >
            <div className="row mb-5">
              <h3>Blacklist de documentos</h3>
              <table className="table table-bordered table-striped table-sm">
                <thead className="light">
                  <tr>
                    <th>Documento</th>
                    <th>Tipo de documento</th>
                    <th>Consultas bloqueadas</th>
                    <th>Observação</th>
                    <th>Anexo</th>
                    <th>Ativo</th>
                    <th>Criado por</th>
                    <th>Criado em</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {blackListData &&
                    blackListData.map(query => (
                      <tr>
                        <td>
                          {formatDocument(query.documentType, query.document)}
                        </td>
                        <td>
                          {DOCUMENT_TYPE_LABELS[query.documentType] ??
                            query.documentType}
                        </td>
                        <td>{query.queryType.join(", ")}</td>
                        <td>{query.observation ?? "N/A"}</td>
                        <td>
                          {query.attachment_url ? (
                            <button
                              type="button"
                              className="btn btn-icon btn-primary"
                              onClick={() =>
                                handleOpenAttachment(query.attachment_url)
                              }
                              disabled={isOperating}
                            >
                              <i className="flaticon2-document"></i>
                            </button>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>{query.active ? "Ativo" : "Inativo"}</td>
                        <td>{query.user}</td>
                        <td>
                          {format(
                            parseISO(query.created_at),
                            "dd/MM/yyyy HH:mm"
                          )}
                        </td>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-icon btn-primary"
                            onClick={() => handleDeleteDocument(query.id)}
                            disabled={isOperating}
                          >
                            <i className="flaticon2-trash"></i>
                          </button>
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip>Ativar/Desativar documento</Tooltip>
                            }
                          >
                            <button
                              type="button"
                              className="btn btn-icon btn-primary"
                              onClick={() =>
                                handleActivateDocument(query.id, query.active)
                              }
                              disabled={isOperating}
                            >
                              <i className="flaticon2-checkmark"></i>
                            </button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
